<label
  [attr.for]="toggleId"
  class="inline-flex cursor-pointer items-center gap-3 select-none"
  [class.opacity-50]="disabled()"
>
  <button
    [id]="toggleId"
    type="button"
    role="switch"
    [attr.aria-checked]="value"
    (click)="toggleValue()"
    [disabled]="disabled()"
    class="relative cursor-pointer inline-flex h-7 w-14 shrink-0 items-center rounded-full border transition-colors duration-300 ease-in-out focus:outline-none"
    [ngClass]="{
      'bg-primary border-primary': value,
      'bg-surface-high border-border': !value
    }"
  >
    <!-- On Icon (shown on left side of track when active) -->
    @if (iconOn()) {
    <span
      aria-hidden="true"
      class="absolute left-2 top-1/2 -translate-y-1/2 flex items-center justify-center transition-opacity duration-200 text-primary-foreground"
      [ngClass]="value ? 'opacity-100' : 'opacity-0'"
    >
      <lucide-icon
        [name]="iconOn()!"
        [size]="14"
      ></lucide-icon>
    </span>
    }

    <!-- Off Icon (shown on right side of track when inactive) -->
    @if (iconOff()) {
    <span
      aria-hidden="true"
      class="absolute right-2 top-1/2 -translate-y-1/2 flex items-center justify-center transition-opacity duration-200 text-muted-foreground"
      [ngClass]="!value ? 'opacity-100' : 'opacity-0'"
    >
      <lucide-icon
        [name]="iconOff()!"
        [size]="14"
      ></lucide-icon>
    </span>
    }

    <!-- The Sliding Thumb -->
    <span
      aria-hidden="true"
      class="pointer-events-none inline-block h-[22px] w-[22px] transform rounded-full shadow-sm ring-0 transition-all duration-300 ease-in-out"
      [ngClass]="value ? 'translate-x-[30px] toggle-thumb-on' : 'translate-x-[2px] toggle-thumb-off'"
    ></span>
  </button>

  <!-- The label text -->
  @if (label()) {
  <span class="text-sm font-medium text-text">{{ label() }}</span>
  }
</label>
